// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1z_Zf","info":"Note_info__1HHvW","note":"Note_note__7QuE4","actions":"Note_actions__31i5H"};